import React, { useContext, useState } from "react"
import * as styles from "./index.module.less"
import Filters from "./Filters"
import Types from "./Types"
import Matches from "./Matches"
import updateQs from "../../SearchParams/updateQs"
import { format } from "date-fns"
import useQueryParams from "../../../utils/useQueryParams"
import { SpaceProfileContext } from "../context"
import ProgressDots from "../../ProgressDots"

const AvailableWorkspaces = ({ uuidFromCms = null }) => {
  const {
    commonData: { data },
  } = useContext(SpaceProfileContext)

  const [teamSize, setTeamSize] = useQueryParams("team_size", 0)
  const [ts, setTs] = useQueryParams("team_size", 0)
  const [date, setDate] = useState(null)

  const [active, setActive] = useState(0)

  const updateTeamSize = (value) => {
    setTeamSize(value)
  }

  const updateDate = (value) => {
    setDate(value)
    if (window.location.pathname.indexOf("/space/") > -1) {
      updateQs("move_in_date", format(value, "yyyy-MM-dd"), true)
    }
  }

  if (!data.id) {
    return (
      <div className={"position-relative mt-5"}>
        <ProgressDots active />
      </div>
    )
  }

  return (
    <div className={styles.wrapper} id={"available_workspaces"}>
      <h2>Available workspace</h2>
      <Filters
        teamSize={!uuidFromCms ? ts : teamSize}
        date={date}
        setTeamSize={!uuidFromCms ? setTs : updateTeamSize}
        setDate={updateDate}
        uuid={uuidFromCms}
        active={active}
        setActive={setActive}
      />
      {uuidFromCms && (
        <Types
          teamSize={teamSize}
          date={date}
          uuid={uuidFromCms}
          openTsModal={() => setActive(1)}
        />
      )}
      {!uuidFromCms && <Matches />}
    </div>
  )
}

export default AvailableWorkspaces
